import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'
import mediaQueries from '../../layout/media-queries'

const chevronCss = (hover) => (theme) =>
  css`
    height: 20px;
    margin-left: 5px;
    fill: none;

    > path {
      stroke-width: 8px;
      d: ${hover
        ? 'path("M20 50 L50 50 L80 50")'
        : 'path("M25 40 L50 65 L75 40")'};
      stroke: ${hover ? theme.colors.blue : theme.colors.gray900};
      transition: all 0.2s ease-out;
    }

    @media (max-width: ${mediaQueries.MEDIUM}) {
      transform: rotate(-90deg);
    }
  `

const ChevronIcon = ({ isOpen }) => (
  <svg css={chevronCss(isOpen)} viewBox="0 0 100 100">
    <path />
  </svg>
)

ChevronIcon.propTypes = {
  isOpen: PropTypes.bool,
}

export default ChevronIcon
